<!-- =========================================================================================
  File Name: UserEdit.vue
  Description: User Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="page-user-edit">
		<bread-crumbs
			:title="$t('UpdateVisitPoint')"
			:subTitle="$t('general.SubtitleVisitPointUpdate')"
			:sizeTitle="30"
			:lineHeightTitle="37"
			:sizeSubTitle="15"
			:lineHeightSubTitle="18"
		>
		</bread-crumbs>
		<vs-alert
			color="danger"
			:title="$t('VisitPointObject.Edit.VisitPointNotFound.Title')"
			:active.sync="visit_point_not_found"
		>
			<span>
				{{
					$t("VisitPointObject.Edit.VisitPointNotFound.Text1") +
					" " +
					$route.params.id +
					" " +
					$t("VisitPointObject.Edit.VisitPointNotFound.Text2")
				}}
			</span>
			<span
				><span>Check</span>
				<router-link :to="{name: 'app-visit-point-list'}" class="text-inherit underline">{{
					$t("VisitPointObject.Edit.AllVisitPoints")
				}}</router-link>
			</span>
		</vs-alert>
		<visit-point-edit-tab-account
			v-if="visitingPoints !== null && visitpointUpdatePermission"
			class="mt-4"
			:data="visitingPoints"
		/>
		<not-permission v-else :message="message"></not-permission>
	</div>
</template>

<script>
import VisitPointEditTabAccount from "./VisitPointEditTabAccount.vue";
import NotPermission from "@/views/pages/NotPermission.vue";
import moduleVisitPoint from "@/store/visit-point/moduleVisitPoint.js";

export default {
	components: {
		VisitPointEditTabAccount,
		NotPermission,
	},
	data() {
		return {
			visitingPoints: null,
			visit_point_not_found: false,
		};
	},
	computed: {
		visitpointUpdatePermission() {
			return this.$store.getters.checkPermission("VISIT_POINT_U");
		},
		message() {
			return `${this.$t(
				"Permissions.RequiredPermissions"
			)} "VISIT_POINT_U" , "ROLE_R", "STATUS_R", "OBJECTS_R", "TYPE_CONFIG_R"`;
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		getVisitPointById(visitPointId) {
			this.openLoading();
			this.$store
				.dispatch("moduleVisitPoint/fetchVisitPointPaginated", {id: [visitPointId]})
				.then((res) => {
					this.visitingPoints = res.records[0];
					this.closeLoading();
				})
				.catch((err) => {
					this.closeLoading();
					this.visit_point_not_found = true;
					console.error(err);
				});
		},
	},
	created() {
		if (!moduleVisitPoint.isRegistered) {
			this.$store.registerModule("moduleVisitPoint", moduleVisitPoint);
			moduleVisitPoint.isRegistered = true;
		}
		this.getVisitPointById(parseInt(this.$route.params.id));
	},
};
</script>
